import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/site/Reveal";
import { ArrowUpRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const coverSrc = (c) => (!c ? null : c.startsWith("http") ? c : `${process.env.REACT_APP_BACKEND_URL}${c}`);
const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" }) : "");

export const BlogTeaser = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/blog/posts`).then(({ data }) => setPosts(data.slice(0, 3))).catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  return (
    <section id="blog-teaser" className="py-20 md:py-28" data-testid="home-blog-teaser">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <Reveal>
          <div className="flex flex-wrap items-end justify-between gap-6">
            <div>
              <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#385244]">Dal nostro blog</p>
              <h2 className="mt-3 font-serif-display font-light text-4xl md:text-5xl text-[#15201A]">
                Guide e consigli per il tuo <em className="italic text-[#385244]">sorriso</em>
              </h2>
            </div>
            <Link
              to="/blog"
              className="inline-flex items-center gap-2 rounded-full border-2 border-[#385244] text-[#385244] hover:bg-[#385244] hover:text-white text-sm font-bold px-6 py-3 transition-colors duration-300"
              data-testid="home-blog-teaser-all-link"
            >
              Tutti gli articoli <ArrowUpRight size={16} />
            </Link>
          </div>
        </Reveal>
        <div className="mt-10 grid md:grid-cols-3 gap-6">
          {posts.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.08}>
              <Link
                to={`/blog/${p.slug}`}
                className="group block bg-white border border-border rounded-[24px] overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 h-full"
                data-testid={`home-blog-teaser-card-${p.slug}`}
              >
                {p.cover_image && (
                  <div className="aspect-[16/10] overflow-hidden">
                    <img src={coverSrc(p.cover_image)} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                )}
                <div className="p-6">
                  <div className="flex items-center gap-3 text-xs">
                    <span className="font-bold uppercase tracking-wider text-[#385244] bg-[#EAF4F8] rounded-full px-3 py-1">{p.category}</span>
                    <span className="text-[#9AA79E]">{fmtDate(p.published_at)}</span>
                  </div>
                  <h3 className="mt-4 font-serif-display font-light text-xl leading-snug text-[#15201A] group-hover:text-[#385244] transition-colors duration-300">
                    {p.title}
                  </h3>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.15}>
          <div className="mt-12 text-center">
            <p className="text-lg text-[#5C6B61]">
              Vedi tutti gli articoli del Blog: sicuramente ti daranno una consapevolezza migliore nella scelta!
            </p>
            <Link
              to="/blog"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#385244] hover:bg-[#2B4035] text-white font-bold px-10 py-4 transition-colors duration-300 active:scale-95"
              data-testid="home-blog-cta-btn"
            >
              Clicca qui <ArrowUpRight size={18} />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
